var path = 'webapps/_directives/appSelectSport/appSelectSport.ng.html';
var html = "<ui-select ng-model=\"vm.model\" theme=\"select2\" style=\"width:100%;\">\r\n   <ui-select-match placeholder=\"Введите или выберите вид спорта\">{{$select.selected.name}}</ui-select-match>\r\n\t<ui-select-choices repeat=\"sport in sports | filter: $select.search\" refresh=\"find($select.search)\" refresh-delay=\"300\">  \r\n\t\t\t<div style=\"margin-left: 1px;\">\r\n\t\t\t\t<div ng-bind-html=\"sport.name | highlight: $select.search\"></div>\r\n\t\t    </div>\r\n\t</ui-select-choices>\r\n</ui-select>\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./_directives/appSelectSport/appSelectSport.ng.html
 ** module id = 21
 ** module chunks = 0
 **/